export type { ButtonColor, ButtonSize, InputProps } from '@/ui/Button'
export { default } from '@/ui/Button'
